/**
 * Что ответ /metadata_merge_subtitles говорит о переводе склеенной реплики.
 *
 * Старый сервер о переводе молчит: он склеивает его, только если перевод есть у ОБЕИХ реплик, и
 * убирать старые файлы остаётся редактору (четыре удаления следом). Новый сервер (translate-python,
 * склейка TP9) склеивает перевод сам, если он есть хотя бы у одной, сам убирает старые файлы и
 * присылает результат полем `merged_translations` — {<короткий код языка: en, es, ch…>: json
 * перевода}; пустой объект — перевода не было ни у одной части. По наличию поля редактор и
 * узнаёт, с каким сервером говорит (kept_translator_work для этого не годится: старый сервер
 * шлёт его в режиме «Без автоправок»). Настоящие ответы — в mergeResponse.fixture.ts.
 */

/** Сервер сам склеил перевод и убрал старые файлы (поле есть, даже если в нём пусто). */
export const serverMergedTargets = (response: unknown): boolean =>
    Boolean(response) && typeof response === "object" && "merged_translations" in (response as object);

/**
 * Склеенный перевод пары: объект, null (перевода нет) или undefined (старый сервер — не знаем).
 * `langs` — варианты имени языка пары (en, en-US, zh/ch…); ключ сервера — короткий код языка
 * пары. Чужой язык (например, _ru.json, оказавшийся в паре en_es) переводом пары не считается.
 */
export const mergedTargetFor = (
    response: any,
    langs: string[],
): { captions?: string } | null | undefined => {
    if (!serverMergedTargets(response)) return undefined;
    const targets = response.merged_translations;
    if (!targets || typeof targets !== "object") return null;
    for (const lang of langs) {
        if (lang && targets[lang] !== undefined) return targets[lang] ?? null;
    }
    return null;
};

/** Варианты имени языка пары для поиска в merged_translations. */
export const pairLangKeys = (appLang: string, wire: string): string[] => {
    const abbr = String(wire || "").split("-")[0].toLowerCase();
    const keys = [appLang, wire, abbr];
    if (abbr === "zh" || appLang === "ch") keys.push("zh", "ch");
    return Array.from(new Set(keys.filter(Boolean)));
};
